export default __webpack_public_path__ + "static/media/title.c2325a02.png";